import React, { useRef, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { fetchData } from "../../utils/functions";

import GeneralInformation from "./tabs/GeneralInformation";
import FeatureInformation from "./tabs/FeatureInformation";
import CommunityFeedback from "./tabs/CommunityFeedback";
import VisualVerification from "./tabs/VisualVerification";
import SummaryFollowup from "./tabs/SummaryFollowup";
import Loader from "../partials/Loader";

const ViewMonitoring = () => {
  const { boqs_proposed_monitoring_id } = useParams();

  const [activeTab, setActiveTab] = useState("General Information");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const scrollRef = useRef(null);
  const [isLeftClicked, setIsLeftClicked] = useState(false);
  const [isRightClicked, setIsRightClicked] = useState(false);

  const scrollTabs = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -200 : 200;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      if (direction === "left") {
        setIsLeftClicked(true);
        setTimeout(() => setIsLeftClicked(false), 200);
      } else {
        setIsRightClicked(true);
        setTimeout(() => setIsRightClicked(false), 200);
      }
    }
  };

  useEffect(() => {
    const getMonitoringDetails = async () => {
      try {
        setLoading(true);
        const response = await fetchData(
          `monitoring-phase/${boqs_proposed_monitoring_id}`
        );
        setData(response.data);
      } catch (error) {
        console.error("Error fetching monitoring details:", error);
      } finally {
        setLoading(false);
      }
    };

    getMonitoringDetails();
  }, [boqs_proposed_monitoring_id]);

  if (loading) {
    return <Loader />;
  }

  const tabs = [
    "General Information",
    "Feature Information",
    "Community Feedback",
    "Visual Verification",
    "Summary & Follow-up",
  ];

  return (
    <div>
      <h1 className="text-[1.475rem] text-black font-bold">
        View Monitoring Phase
      </h1>

      <div className="mt-6 mb-8">
        <div className="flex items-center rounded-t-lg bg-[#fdf5ec] relative">
          <button
            onClick={() => scrollTabs("left")}
            className={`text-xl px-4 py-2 font-bold rounded-lg transition-colors ${
              isLeftClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            «
          </button>

          <div
            ref={scrollRef}
            className="flex gap-4 overflow-hidden scrollbar-hide"
          >
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-10 py-2 font-semibold whitespace-nowrap ${
                  activeTab === tab ? "bg-[#caa316] text-white" : "text-black"
                }`}
                style={{
                  borderTopLeftRadius: "13px",
                  borderTopRightRadius: "30px",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <button
            onClick={() => scrollTabs("right")}
            className={`ml-auto text-xl px-4 py-2 rounded-lg font-bold transition-colors ${
              isRightClicked ? "bg-[#caa316] text-white" : "text-black"
            }`}
          >
            »
          </button>
        </div>

        <div className="bg-white rounded-b-lg shadow-md p-6">
          {activeTab === "General Information" && (
            <GeneralInformation data={data} />
          )}
          {activeTab === "Feature Information" && (
            <FeatureInformation data={data} />
          )}
          {activeTab === "Community Feedback" && (
            <CommunityFeedback data={data} />
          )}
          {activeTab === "Visual Verification" && (
            <VisualVerification data={data} />
          )}
          {activeTab === "Summary & Follow-up" && (
            <SummaryFollowup data={data} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewMonitoring;